import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities'
import React from 'react'
import { ButtonTypeGroup } from 'src/editor/shared/settings/groups/button-type-group'
import { LoginButtonEntityInterface } from 'src/shared/entities/login-button/login-button-entity.schema'
import { CommonButtonSettings } from '../common-button-settings'

export const LoginButtonSettings = ({
  entity,
  defaultEntity,
}: SettingsProps<LoginButtonEntityInterface>) => {
  return (
    <>
      <ButtonTypeGroup entity={entity} />
      <CommonButtonSettings entity={entity} defaultEntity={defaultEntity} />
    </>
  )
}
